import gql from 'graphql-tag';

const PRICE_TIER_FRAGMENT = gql`
  fragment priceTier on PriceTier {
    tierId
    name
    to
    from
    registrantLimit
    packageSize
    monthlyPrice
    pricePerAdditional
    annualPrice
    annualPricePerMonth
    annualPricePerAdditional
    annualPricePerAdditionalPerMonth
  }
`;

export const PRICE_PLAN_FRAGMENT = gql`
  fragment pricePlan on PricePlan {
    pricePlan {
      ...priceTier
    }
    discountedPricePlan {
      ...priceTier
    }
    coupon {
      id
      name
      percent_off
      amount_off
    }
  }
  ${PRICE_TIER_FRAGMENT}
`;

export const GET_PRICE = gql`
  query getRegularPrice {
    price {
      pricePlan {
        ...priceTier
      }
    }
  }
  ${PRICE_TIER_FRAGMENT}
`;

export const GET_DISCOUNTED_PRICE_CODE = gql`
  query getDiscountedPriceByCode($code: String!) {
    getDiscountedPriceByCode(code: $code) {
      ...pricePlan
    }
  }
  ${PRICE_PLAN_FRAGMENT}
`;

export const GET_DISCOUNTED_PRICE_TEAM = gql`
  query getDiscountedPriceByTeam {
    getDiscountedPriceByTeam {
      ...pricePlan
    }
  }
  ${PRICE_PLAN_FRAGMENT}
`;
